var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.value
    ? _c(
        "w-menu",
        {
          ref: "menu",
          attrs: {
            value: _vm.value,
            "close-on-blur": "",
            "close-on-click": "",
            x: _vm.x,
            y: _vm.mouseY,
            right: _vm.isRight,
            width: "auto",
            "auto-up": "",
          },
          on: {
            input: function ($event) {
              return _vm.onInput($event)
            },
          },
        },
        [
          _vm.value
            ? _c(
                "w-select-item-list",
                {
                  ref: "list",
                  attrs: { "rounded-top": "", "rounded-bottom": "" },
                },
                _vm._l(_vm.items, function (item, i) {
                  return _c(
                    "w-select-item",
                    {
                      key: i,
                      ref: "selectItems",
                      refInFor: true,
                      staticClass: "w-select-option",
                      attrs: { tabindex: 0 },
                      on: {
                        click: function ($event) {
                          return _vm.onClick(item.value)
                        },
                      },
                    },
                    [
                      _c(
                        "w-row",
                        {
                          staticClass: "context-menu-item",
                          attrs: { center: "" },
                        },
                        [
                          item.icon
                            ? _c("w-fa", {
                                staticClass: "context-menu-item-icon mr",
                                attrs: { icon: item.icon },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(item.text) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }